export default function BlogSkeleton(){
    return(
        <div className="animate-pulse grid md:grid-cols-3 gap-6">
            {[...Array(6)].map((_,i)=>(
            <div key={i} className="border rounded-lg overflow-hidden">
                <div className="bg-gray-200 h-48 w-full"></div>
                    <div className="p-4 space-y-3">
                    <div className="h-4 bg-gray-200 w-3/4"></div>
                    <div className="h-3 bg-gray-200 w-1/2"></div>
                    <div className="h-3 bg-gray-200 w-1/3"></div>
                </div>
            </div>
            ))}
        </div>

    )

}